import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import { compose, withHandlers } from "recompose";

import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import Button from "react-md/lib/Buttons/Button";

import TextField from "../form/TextField";
import SelectField from "../form/SelectField";
import * as Validation from "../form/Validation";

import { setActiveForm } from "../../actions/appActions";
import {
  updateResource,
  getResourcesForAdmin
} from "../../actions/resourceActions";

const options = [
  { value: "touch", label: "touch" },
  { value: "lagoon", label: "lagoon" },
  { value: "erpbridge", label: "erpbridge" }
];

const Info = ({
  handleSubmit,
  history,
  initialValues,
  activeForm,
  setActiveForm
}) => {
  return (
    <Card raise>
      {activeForm === "adminResourcesEditResourceForm" ? (
        <CardText>
          <form onSubmit={handleSubmit}>
            <Field
              component={TextField}
              label="Klientské ID"
              name="clientId"
              validate={[Validation.required]}
            />
            <Field
              component={SelectField}
              label="Typ klienta"
              name="clientType"
              menuItems={options}
              validate={[Validation.required]}
            />
            <Field
              component={TextField}
              label="Secret klienta"
              name="clientSecret"
              validate={[Validation.required]}
            />
            <div className="flex-row flex-right">
              <Button
                flat
                label="Zrušit"
                className="btn"
                onClick={() => setActiveForm(null)}
              />
              <Button
                flat
                primary
                label="Uložit"
                type="submit"
                className="btn btn-primary"
              />
            </div>
          </form>
        </CardText>
      ) : (
        <CardText
          onClick={() => setActiveForm("adminResourcesEditResourceForm")}
        >
          <div className="flex-row">
            <p className="request-label">Klientské ID:</p>
            <p>{initialValues.clientId}</p>
          </div>
          <div className="flex-row">
            <p className="request-label">Typ klienta:</p>
            <p>{initialValues.clientType}</p>
          </div>
          <div className="flex-row">
            <p className="request-label">Secret klienta:</p>
            <p>{initialValues.clientSecret}</p>
          </div>
        </CardText>
      )}
    </Card>
  );
};

export default compose(
  connect(({ app: { form: { activeForm } } }) => ({ activeForm }), {
    setActiveForm,
    updateResource,
    getResourcesForAdmin
  }),
  withHandlers({
    onSubmit: () => async (formData, dispatch, props) => {
      const {
        setActiveForm,
        initialValues,
        updateResource,
        getResourcesForAdmin
      } = props;
      const { clientId, clientType, clientSecret } = formData;

      if (
        await updateResource({
          id: initialValues.id,
          clientId,
          clientType,
          clientSecret
        })
      ) {
        getResourcesForAdmin(initialValues.id);
        setActiveForm(null);
      } else
        throw new SubmissionError({
          clientSecret: "Úprava se nezdařila."
        });
    }
  }),
  reduxForm({ form: "adminResourcesEditResourceForm" })
)(Info);



// WEBPACK FOOTER //
// ./src/components/resource/Info.js